export default __webpack_public_path__ + "static/media/2022-2.04f18618.jpg";